import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { ADMIN_CAP_PHAT_TRANG_THIET_BI_PREFIX_URL } from './constants/config.admin-cap-phat-trang-thiet-bi'

const ListPageAdminCapPhatTrangThietBi = lazy(
  () => import('./pages/ListPage.AdminCapPhatTrangThietBi')
)

const AdminCapPhatTrangThietBiRouters: AppRouterItem[] = [
  {
    path: `${ADMIN_CAP_PHAT_TRANG_THIET_BI_PREFIX_URL}/`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageAdminCapPhatTrangThietBi />
      </LoadingLazyComponents>
    ),
  },
]

export default AdminCapPhatTrangThietBiRouters
